const USE_3_MONTH_INTEREST_RATE = false;

export const featureFlags = {
  use3MonthInterestRate: USE_3_MONTH_INTEREST_RATE,
} as const;
